import { getAssetsUrl } from './config';

const image = new Image();
const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');

function getFramingName(api) {
  if (
    Object.values(
      api.scene.getAll({ name: '6R*', plug: 'Properties', property: 'visible' })
    ).indexOf(true) !== -1
  ) {
    const name = api.scene.get({
      name: '6R6ZB',
      plug: 'Properties',
      property: 'visible',
    });
    return name ? '6R6ZB' : '6R4AF';
  } else if (
    Object.values(
      api.scene.getAll({ name: '8R*', plug: 'Properties', property: 'visible' })
    ).indexOf(true) !== -1
  ) {
    const name = api.scene.get({
      name: '8R6ZB',
      plug: 'Properties',
      property: 'visible',
    });
    return name ? '8R6ZB' : '8R6AF';
  } else if (
    Object.values(
      api.scene.getAll({ name: '6T*', plug: 'Properties', property: 'visible' })
    ).indexOf(true) !== -1
  ) {
    const name = api.scene.get({
      name: '6T4*',
      plug: 'Properties',
      property: 'visible',
    });
    return name ? '6T4AF' : '6T6ZB';
  } else if (
    Object.values(
      api.scene.getAll({ name: '8T*', plug: 'Properties', property: 'visible' })
    ).indexOf(true) !== -1
  ) {
    const name = api.scene.get({
      name: '8T6Z*',
      plug: 'Properties',
      property: 'visible',
    });
    return name ? '8T6ZB' : '8T6AF';
  } else {
    return 'Null';
  }
}

function createOrder(body) {
  fetch(`https://mythreekit.com/api/organizations/masa/orders`, {
    method: 'POST',
    mode: 'cors',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(body),
  }).then(res => {
    if (res.status === 200) {
    } else {
      const button = document.getElementById('downloadPDF');
      if (button) button.innerHTML = 'download PDF (failed to send an email)';
      setTimeout(() => {
        button.innerHTML = 'download PDF';
      }, 3000);
    }
  });
}

async function sendRequest(data, attr, callback) {
  const { customer, productId, sceneId, configuration } = attr;
  const body = {
    customer,
    productId,
    sceneId,
    configuration,
    metadata: {
      data,
    },
  };
  callback({ processPercent: 55 });
  createOrder(body);
  if (data) {
    const pdf = await fetch(`/pdfData`, {
      method: 'POST',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(body),
    }).then(res => {
      console.log(res.status);
      if (res.status === 200) {
        callback({ processPercent: 75 });
        return res.blob();
      }
      return null;
    });
    callback({ processPercent: 90 });
    // setTimeout(() => {
    const button = document.getElementById('downloadPDF');
    if (pdf) {
      if (button) button.innerHTML = 'download PDF';
      const link = document.createElement('a');
      link.download = `${data.name}.pdf`;
      link.href = URL.createObjectURL(pdf);
      link.click();
    } else {
      if (button) button.innerHTML = 'download PDF (failed)';
      setTimeout(() => {
        if (button) button.innerHTML = 'download PDF';
      }, 2000);
    }
  }

  // }, 200);
}
function downloadURI(uri, name) {
  return fetch(uri.replace(/\s/g, '+'))
    .then(function(resp) {
      return resp.blob();
    })
    .then(function(blob) {
      const link = document.createElement('a');
      link.download = name;
      link.href = URL.createObjectURL(blob);
      link.click();
    });
}

export default {
  'Vision-300-series': async function(api, attr, callback) {
    const { productName } = attr;
    const number = productName.match(/\d+$/);
    if (number && number[0]) {
      const url = `https://cdn.threehub.com/clients/masa/assets/specSheet/vision300Series/Vision Series-V${number[0]}.pdf`;
      downloadURI(url, `Vision Series-V${number[0]}.pdf`);
      await sendRequest(
        { name: `Vision Series-V${number[0]}` },
        attr,
        callback
      );
    }

    callback({ processPercent: 100 }, () => {
      callback({ processPercent: undefined });
    });
  },

  'Vision-400-series': async function(api, attr, callback) {
    const { productName } = attr;
    const number = productName.match(/\d+$/);
    if (number && number[0]) {
      const url = `https://cdn.threehub.com/clients/masa/assets/specSheet/vision400Series/Vision Series-V${number[0]}.pdf`;
      downloadURI(url, `Vision Series-V${number[0]}.pdf`);
      await sendRequest(
        { name: `Vision Series-V${number[0]}` },
        attr,
        callback
      );
    }

    callback({ processPercent: 100 }, () => {
      callback({ processPercent: undefined });
    });
  },
  Extrudeck: async function(api, attr, callback) {
    const baseSceneId = attr.sceneId;
    const data = {};
    const config = api.configuration.getConfiguration();
    data.config = config;

    let cameraId;
    let ratio;
    if (config['Mounting'] === 'Hanger Rod Supported') {
      cameraId = api.scene.find('Camera_Mounting1');
      ratio = api.scene.get({
        name: 'Camera_Mounting1',
        plug: 'Camera',
        property: 'aspectRatio',
      });
    } else if (config['Mounting'] === 'Cantilevered') {
      cameraId = api.scene.find('Camera_Mounting2');
      ratio = api.scene.get({
        name: 'Camera_Mounting2',
        plug: 'Camera',
        property: 'aspectRatio',
      });
    } else if (config['Mounting'] === 'Post Supported') {
      cameraId = api.scene.find('Camera_Mounting3');
      ratio = api.scene.get({
        name: 'Camera_Mounting3',
        plug: 'Camera',
        property: 'aspectRatio',
      });
    }
    data.cameraId = cameraId;
    data.ratio = ratio;
    data.framing =
      '1. Type:  8” X .125” Extruded Aluminum “J” Channel (6063-T5)';
    // data.framingImg = await getDataURL(getAssetsUrl(['image', 'framing.jpg']));

    data.decking =
      '1. Type:  3” x 6” x .090” Interlocking Extruded Aluminum Flat Soffit Decking (6063-T5)';
    // data.deckingImg = await getDataURL(getAssetsUrl(['image', 'decking.jpg']));

    if (config['Mounting'] === 'Hanger Rod Supported') {
      // data.mountingImg = await getDataURL('Hanger Rod.png', api);
      data.mounting = `Type:  Hanger Rod Supported- 3” x 2 1/2" x 1/4” I-Beam Outriggers (6061-T6511) W/3/4"D Schedule 40 Steel Pipe (A500), Escutcheon Plate - ${config[
        'Escutcheon Plates'
      ]}: `;
    } else if (config['Mounting'] === 'Cantilevered') {
      // data.mountingImg = await getDataURL('Cantilevered.png', api);
      data.mounting =
        'Type: Cantilevered- 3” x 3” x 1/4” SQU Steel Tube (A500)';
    } else {
      // data.mountingImg = await getDataURL('Post Mount.png', api);
      data.mounting =
        'Type:  Post Supported- 4” x 4” x1/8” SQU Extruded Aluminum Tube (6061-T6511)';
    }

    if (config['Escutcheon Plates']) {
      // data.hangerImg = await getDataURL(
      //   config['Escutcheon Plates'].replace(/[{()}]/g, '', '') + '.PNG',
      //   api
      // );
    }

    let content;
    if (config['Profiles'] && config['Profiles'] !== 'None') {
      // data.profileImg = await getDataURL(
      //   config['Profiles'].replace(/[{()}]/g, '', '') + '.PNG',
      //   api
      // );
      content = config['Profiles'];
    } else {
      content = 'None';
    }

    data.profileAttrName = `1. Profile Variables  - ${content}`;

    if (config['Crowns'] && config['Crowns'] !== 'None') {
      // data.crownImg = await getDataURL(
      //   config['Crowns'].replace(/[{()}]/g, '', '') + '.PNG',
      //   api
      // );
      content = config['Crowns'];
    } else {
      content = 'None';
    }

    data.crownAttrName = `1. Crown Variables - ${content}`;

    if (config['Lighting'] === 'LD-5') {
      // data.lightingImg = await getDataURL(
      //   config['Lighting'].replace(/[{()}]/g, '', '') + '.PNG',
      //   api
      // );
      data.lighting =
        '4” LED SQU (Standard)  W/ Welded Light Box, 5”x 5” x 1/8* Extruded Aluminum SQU Tube (6061-T6511)  (See Light spec. for details.)';
    } else if (config['Lighting'] === 'LD-11') {
      // data.lightingImg = await getDataURL(
      //   config['Lighting'].replace(/[{()}]/g, '', '') + '.PNG',
      //   api
      // );
      data.lighting =
        '11” LED SQU  W/ Welded Light Box, Formed .090” Aluminum ( AA5052-H32)';
    } else {
      data.lighting = 'None';
    }

    if (config['Drainage'] === 'Diverter (S)') {
      // data.drainageImg = await getDataURL(
      //   config['Drainage'].replace(/[{()}]/g, '', '') + '.PNG',
      //   api
      // );
      data.drainage =
        'Diverter Plate (Standard) – Punched from Light Gauge Aluminum';
    } else if (config['Drainage'] === 'Down Spout') {
      // data.drainageImg = await getDataURL(
      //   config['Drainage'].replace(/[{()}]/g, '', '') + '.PNG',
      //   api
      // );
      data.drainage =
        'Downspout-  2” x 3” x 1/8” Extruded Aluminum Rectangular Tube (6061-T6511)';
    }

    if (config['Obscurity Screen']) {
      data.obscurityScreen =
        ' Debris Screen Cover - Single Flange 1” x 1” x 1/8” Extruded Aluminum SQU Tube (6061-T6511),  Fabric Ferrari Cover Soltis 86 (selected by architect from MASA color choices)';
      // data.obscurityScreenImg = await getDataURL(
      //   getAssetsUrl(['image', 'obscurity.jpg'])
      // );
    } else {
      data.obscurityScreen = '- None';
    }
    data.sceneId = baseSceneId;
    data.name = 'extrudeck';
    callback({ processPercent: 40 });
    await sendRequest(data, attr, callback);
    callback({ processPercent: 100 }, () => {
      callback({ processPercent: undefined });
    });
  },
  Ecoshade: async function(api, attr, callback) {
    const baseSceneId = attr.sceneId;
    const data = {};
    data.mainImg = '';
    const config = api.configuration.getConfiguration();

    let cameraId;
    let ratio;
    if (config['Mounting'] === 'Hanger Rod') {
      cameraId = api.scene.find('CameraMounting2');
      ratio = api.scene.get({
        name: 'CameraMounting2',
        plug: 'Camera',
        property: 'aspectRatio',
      });
    } else if (config['Mounting'] === 'Cantilevered') {
      cameraId = api.scene.find('CameraMounting1');
      ratio = api.scene.get({
        name: 'CameraMounting1',
        plug: 'Camera',
        property: 'aspectRatio',
      });
    }

    let tempConfig = JSON.parse(JSON.stringify(config));
    for (let key in tempConfig) {
      const value = tempConfig[key];
      if (key.indexOf('Profiles') !== -1 || key.indexOf('Crowns') !== -1) {
        delete tempConfig[key];
        tempConfig[key] = value;
      }
    }
    data.config = tempConfig;
    data.cameraId = cameraId;
    data.ratio = ratio;
    if (config['Mounting'] === 'Hanger Rod') {
      let option = 'None';
      if (config['Escutcheon Plates '] === 'ESCS') {
        option = ' -- Escutcheon Plate - 6 Square';
      } else if (config['Escutcheon Plates '] === 'ESCR') {
        option = ' -- Escutcheon Plate - 6 Round';
      } else if (config['Escutcheon Plates '] === 'ESCC') {
        option = ' -- Escutcheon Plate - 6 Contemporary';
      } else if (config['Escutcheon Plates '] === 'ESCD') {
        option = ' -- Escutcheon Plate - 6 Doric';
      }

      data.mounting = `1. Hanger Rod Supported- W/1/2 "D Schedule 40 Steel Pipe (A500) ${option}`;

      // data.mountingImg = await getDataURL(
      //   config['Mounting'].replace(/[{()}\s]/g, '', '') + '.PNG',
      //   api
      // );

      // data.hangerImg = await getDataURL(
      //   config['Escutcheon Plates '].replace(/[{()}\s]/g, '', '') + '.PNG',
      //   api
      // );
    } else {
      data.mounting =
        '1. Cantilevered Outriggers (Standard) – Aluminum Plate (6061-T6)';

      // data.mountingImg = await getDataURL(
      //   config['Mounting'].replace(/[{()}\s]/g, '', '') + '.PNG',
      //   api
      // );
    }

    let frameName = getFramingName(api);

    // Frame Type is closed
    if (frameName.charAt(1) === 'R') {
      data.framing =
        'B. Closed Framing: Formed C Channel w/ Aluminum Plate Outriggers (6061-T6)';
      data.framingAttrName = `1. ${frameName}`;
      // data.framingImg = await getDataURL(frameName + '.PNG', api);
    } else {
      data.framing =
        'B. Open Framing (Tapered):  Aluminum Plate (6061-T6) w/ Round Nose ';

      data.framingAttrName = `1. ${frameName + config['Extended Infills']
        ? ' - Extended Infills'
        : ' - Flush Infills'}`;
      // data.framingImg = await getDataURL(frameName + '.PNG', api);
    }

    // C. Profiles
    if (
      frameName &&
      frameName.charAt(0) === '6' &&
      config['Frame Type'].indexOf('Closed') !== -1
    ) {
      if (config['6" Profiles '] !== 'None') {
        // data.profileImg = await getDataURL(
        //   config['6" Profiles '] + '.PNG',
        //   api
        // );
        data.profileAttrName = `1. ${config['6" Profiles ']}`;
      } else {
        data.profileAttrName = '1. None';
      }

      if (config['6" Crowns '] && config['6" Crowns '] !== 'None') {
        // data.crownImg = await getDataURL(config['6" Crowns '] + '.PNG', api);
        data.crownAttrName = `1. ${config['6" Crowns ']}`;
      } else {
        data.crownAttrName = '1. None';
      }
    } else if (
      frameName &&
      frameName.charAt(0) === '8' &&
      config['Frame Type'].indexOf('Closed') !== -1
    ) {
      if (config['8" Profiles '] !== 'None') {
        // data.profileImg = await getDataURL(
        //   config['8" Profiles '] + '.PNG',
        //   api
        // );
        data.profileAttrName = `1. ${config['8" Profiles ']}`;
      } else {
        data.profileAttrName = '1. None';
      }

      if (config['8" Crowns '] && config['8" Crowns '] !== 'None') {
        // data.crownImg = await getDataURL(config['8" Crowns '] + '.PNG', api);
        data.crownAttrName = `1. ${config['8" Crowns ']}`;
      } else {
        data.crownAttrName = '1. None';
      }
    } else {
      data.profileAttrName = '1. None';
      data.crownAttrName = '1. None';
    }
    data.sceneId = baseSceneId;
    data.name = 'ecoshade';
    await sendRequest(data, attr, callback);
    callback({ processPercent: 100 }, () => {
      callback({ processPercent: undefined });
    });
  },
};



// WEBPACK FOOTER //
// ./src/modules/pdf.js